/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * The SKY API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BadRequestResponse,
  ConflictResponse,
  ForbiddenResponse,
  GetCaseGuests200Item,
  GetCaseShareTokens200,
  GetPasswordRules200,
  GetUserGuestAccesses200Item,
  InternalServerErrorResponse,
  InviteUserBody,
  NotFoundResponse,
  ShareCase200,
  ShareCase201,
  ShareCaseBody,
  UnauthorizedResponse,
  UpdateCurrentUserBody,
  UpdateUserRoleBody,
  User
} from '../model';

import { customInstance } from '../../custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Returns the current user
 */
export const getCurrentUser = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<User>(
      {url: `/users/me`, method: 'GET', signal
    },
      options);
    }




export const getGetCurrentUserQueryKey = () => {
    return [
    `/users/me`
    ] as const;
    }


export const getGetCurrentUserQueryOptions = <TData = Awaited<ReturnType<typeof getCurrentUser>>, TError = UnauthorizedResponse | InternalServerErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCurrentUserQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentUser>>> = ({ signal }) => getCurrentUser(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCurrentUserQueryResult = NonNullable<Awaited<ReturnType<typeof getCurrentUser>>>
export type GetCurrentUserQueryError = UnauthorizedResponse | InternalServerErrorResponse


export function useGetCurrentUser<TData = Awaited<ReturnType<typeof getCurrentUser>>, TError = UnauthorizedResponse | InternalServerErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentUser>>,
          TError,
          Awaited<ReturnType<typeof getCurrentUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCurrentUser<TData = Awaited<ReturnType<typeof getCurrentUser>>, TError = UnauthorizedResponse | InternalServerErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentUser>>,
          TError,
          Awaited<ReturnType<typeof getCurrentUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCurrentUser<TData = Awaited<ReturnType<typeof getCurrentUser>>, TError = UnauthorizedResponse | InternalServerErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns the current user
 */

export function useGetCurrentUser<TData = Awaited<ReturnType<typeof getCurrentUser>>, TError = UnauthorizedResponse | InternalServerErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCurrentUserQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Update the current user's information
 */
export const updateCurrentUser = (
    updateCurrentUserBody: UpdateCurrentUserBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<User>(
      {url: `/users/me`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateCurrentUserBody, signal
    },
      options);
    }




export const getUpdateCurrentUserMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCurrentUser>>, TError,{data: UpdateCurrentUserBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCurrentUser>>, TError,{data: UpdateCurrentUserBody}, TContext> => {

const mutationKey = ['updateCurrentUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCurrentUser>>, {data: UpdateCurrentUserBody}> = (props) => {
          const {data} = props ?? {};

          return  updateCurrentUser(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCurrentUserMutationResult = NonNullable<Awaited<ReturnType<typeof updateCurrentUser>>>
    export type UpdateCurrentUserMutationBody = UpdateCurrentUserBody
    export type UpdateCurrentUserMutationError = BadRequestResponse | UnauthorizedResponse | InternalServerErrorResponse

    /**
 * @summary Update the current user's information
 */
export const useUpdateCurrentUser = <TError = BadRequestResponse | UnauthorizedResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCurrentUser>>, TError,{data: UpdateCurrentUserBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateCurrentUser>>,
        TError,
        {data: UpdateCurrentUserBody},
        TContext
      > => {
      return useMutation(getUpdateCurrentUserMutationOptions(options), queryClient);
    }
    /**
 * @summary Returns the list of users in the current organization
 */
export const listUsers = (
    organizationId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<User[]>(
      {url: `/organizations/${organizationId}/users`, method: 'GET', signal
    },
      options);
    }




export const getListUsersQueryKey = (organizationId: string,) => {
    return [
    `/organizations/${organizationId}/users`
    ] as const;
    }


export const getListUsersQueryOptions = <TData = Awaited<ReturnType<typeof listUsers>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListUsersQueryKey(organizationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listUsers>>> = ({ signal }) => listUsers(organizationId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: organizationId !== null && organizationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListUsersQueryResult = NonNullable<Awaited<ReturnType<typeof listUsers>>>
export type ListUsersQueryError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse


export function useListUsers<TData = Awaited<ReturnType<typeof listUsers>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUsers>>,
          TError,
          Awaited<ReturnType<typeof listUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUsers<TData = Awaited<ReturnType<typeof listUsers>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUsers>>,
          TError,
          Awaited<ReturnType<typeof listUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUsers<TData = Awaited<ReturnType<typeof listUsers>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns the list of users in the current organization
 */

export function useListUsers<TData = Awaited<ReturnType<typeof listUsers>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListUsersQueryOptions(organizationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Update the user's role
 */
export const updateUserRole = (
    organizationId: string,
    userId: string,
    updateUserRoleBody: UpdateUserRoleBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<User>(
      {url: `/organizations/${organizationId}/users/${userId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateUserRoleBody, signal
    },
      options);
    }




export const getUpdateUserRoleMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserRole>>, TError,{organizationId: string;userId: string;data: UpdateUserRoleBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateUserRole>>, TError,{organizationId: string;userId: string;data: UpdateUserRoleBody}, TContext> => {

const mutationKey = ['updateUserRole'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUserRole>>, {organizationId: string;userId: string;data: UpdateUserRoleBody}> = (props) => {
          const {organizationId,userId,data} = props ?? {};

          return  updateUserRole(organizationId,userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserRoleMutationResult = NonNullable<Awaited<ReturnType<typeof updateUserRole>>>
    export type UpdateUserRoleMutationBody = UpdateUserRoleBody
    export type UpdateUserRoleMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Update the user's role
 */
export const useUpdateUserRole = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserRole>>, TError,{organizationId: string;userId: string;data: UpdateUserRoleBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateUserRole>>,
        TError,
        {organizationId: string;userId: string;data: UpdateUserRoleBody},
        TContext
      > => {
      return useMutation(getUpdateUserRoleMutationOptions(options), queryClient);
    }
    /**
 * @summary Delete the user from the organization
 */
export const deleteUser = (
    organizationId: string,
    userId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/organizations/${organizationId}/users/${userId}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteUserMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUser>>, TError,{organizationId: string;userId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteUser>>, TError,{organizationId: string;userId: string}, TContext> => {

const mutationKey = ['deleteUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUser>>, {organizationId: string;userId: string}> = (props) => {
          const {organizationId,userId} = props ?? {};

          return  deleteUser(organizationId,userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteUserMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUser>>>

    export type DeleteUserMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Delete the user from the organization
 */
export const useDeleteUser = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUser>>, TError,{organizationId: string;userId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteUser>>,
        TError,
        {organizationId: string;userId: string},
        TContext
      > => {
      return useMutation(getDeleteUserMutationOptions(options), queryClient);
    }
    /**
 * @summary Invite a user to the organization
 */
export const inviteUser = (
    organizationId: string,
    inviteUserBody: InviteUserBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<User>(
      {url: `/organizations/${organizationId}/invite`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: inviteUserBody, signal
    },
      options);
    }




export const getInviteUserMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inviteUser>>, TError,{organizationId: string;data: InviteUserBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof inviteUser>>, TError,{organizationId: string;data: InviteUserBody}, TContext> => {

const mutationKey = ['inviteUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof inviteUser>>, {organizationId: string;data: InviteUserBody}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  inviteUser(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InviteUserMutationResult = NonNullable<Awaited<ReturnType<typeof inviteUser>>>
    export type InviteUserMutationBody = InviteUserBody
    export type InviteUserMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse

    /**
 * @summary Invite a user to the organization
 */
export const useInviteUser = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inviteUser>>, TError,{organizationId: string;data: InviteUserBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof inviteUser>>,
        TError,
        {organizationId: string;data: InviteUserBody},
        TContext
      > => {
      return useMutation(getInviteUserMutationOptions(options), queryClient);
    }
    /**
 * @summary Create a guest user and generate a share link for a case
 */
export const shareCase = (
    organizationId: string,
    projectId: string,
    shareCaseBody: ShareCaseBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ShareCase200 | ShareCase201>(
      {url: `/organizations/${organizationId}/projects/${projectId}/share`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: shareCaseBody, signal
    },
      options);
    }




export const getShareCaseMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof shareCase>>, TError,{organizationId: string;projectId: string;data: ShareCaseBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof shareCase>>, TError,{organizationId: string;projectId: string;data: ShareCaseBody}, TContext> => {

const mutationKey = ['shareCase'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof shareCase>>, {organizationId: string;projectId: string;data: ShareCaseBody}> = (props) => {
          const {organizationId,projectId,data} = props ?? {};

          return  shareCase(organizationId,projectId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ShareCaseMutationResult = NonNullable<Awaited<ReturnType<typeof shareCase>>>
    export type ShareCaseMutationBody = ShareCaseBody
    export type ShareCaseMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Create a guest user and generate a share link for a case
 */
export const useShareCase = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof shareCase>>, TError,{organizationId: string;projectId: string;data: ShareCaseBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof shareCase>>,
        TError,
        {organizationId: string;projectId: string;data: ShareCaseBody},
        TContext
      > => {
      return useMutation(getShareCaseMutationOptions(options), queryClient);
    }
    /**
 * @summary Get list of guests who have access to a specific case
 */
export const getCaseGuests = (
    organizationId: string,
    projectId: string,
    caseId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GetCaseGuests200Item[]>(
      {url: `/organizations/${organizationId}/projects/${projectId}/cases/${caseId}/guests`, method: 'GET', signal
    },
      options);
    }




export const getGetCaseGuestsQueryKey = (organizationId: string,
    projectId: string,
    caseId: string,) => {
    return [
    `/organizations/${organizationId}/projects/${projectId}/cases/${caseId}/guests`
    ] as const;
    }


export const getGetCaseGuestsQueryOptions = <TData = Awaited<ReturnType<typeof getCaseGuests>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(organizationId: string,
    projectId: string,
    caseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCaseGuests>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCaseGuestsQueryKey(organizationId,projectId,caseId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCaseGuests>>> = ({ signal }) => getCaseGuests(organizationId,projectId,caseId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: organizationId !== null && organizationId !== undefined && projectId !== null && projectId !== undefined && caseId !== null && caseId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCaseGuests>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCaseGuestsQueryResult = NonNullable<Awaited<ReturnType<typeof getCaseGuests>>>
export type GetCaseGuestsQueryError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse


export function useGetCaseGuests<TData = Awaited<ReturnType<typeof getCaseGuests>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    projectId: string,
    caseId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCaseGuests>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCaseGuests>>,
          TError,
          Awaited<ReturnType<typeof getCaseGuests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCaseGuests<TData = Awaited<ReturnType<typeof getCaseGuests>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    projectId: string,
    caseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCaseGuests>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCaseGuests>>,
          TError,
          Awaited<ReturnType<typeof getCaseGuests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCaseGuests<TData = Awaited<ReturnType<typeof getCaseGuests>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    projectId: string,
    caseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCaseGuests>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get list of guests who have access to a specific case
 */

export function useGetCaseGuests<TData = Awaited<ReturnType<typeof getCaseGuests>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    projectId: string,
    caseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCaseGuests>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCaseGuestsQueryOptions(organizationId,projectId,caseId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Returns share tokens for the authenticated guest user.
 * - If caseId is a master version (ROOT type): returns all share tokens for all versions
 * - If caseId is a non-master version: returns only the token for the current case
 * Non-guest users receive an empty array.
 * @summary Get all share tokens for the current guest user
 */
export const getCaseShareTokens = (
    organizationId: string,
    projectId: string,
    caseId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GetCaseShareTokens200>(
      {url: `/organizations/${organizationId}/projects/${projectId}/cases/${caseId}/share-tokens`, method: 'GET', signal
    },
      options);
    }




export const getGetCaseShareTokensQueryKey = (organizationId: string,
    projectId: string,
    caseId: string,) => {
    return [
    `/organizations/${organizationId}/projects/${projectId}/cases/${caseId}/share-tokens`
    ] as const;
    }


export const getGetCaseShareTokensQueryOptions = <TData = Awaited<ReturnType<typeof getCaseShareTokens>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(organizationId: string,
    projectId: string,
    caseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCaseShareTokens>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCaseShareTokensQueryKey(organizationId,projectId,caseId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCaseShareTokens>>> = ({ signal }) => getCaseShareTokens(organizationId,projectId,caseId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: organizationId !== null && organizationId !== undefined && projectId !== null && projectId !== undefined && caseId !== null && caseId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCaseShareTokens>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCaseShareTokensQueryResult = NonNullable<Awaited<ReturnType<typeof getCaseShareTokens>>>
export type GetCaseShareTokensQueryError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse


export function useGetCaseShareTokens<TData = Awaited<ReturnType<typeof getCaseShareTokens>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    projectId: string,
    caseId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCaseShareTokens>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCaseShareTokens>>,
          TError,
          Awaited<ReturnType<typeof getCaseShareTokens>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCaseShareTokens<TData = Awaited<ReturnType<typeof getCaseShareTokens>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    projectId: string,
    caseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCaseShareTokens>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCaseShareTokens>>,
          TError,
          Awaited<ReturnType<typeof getCaseShareTokens>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCaseShareTokens<TData = Awaited<ReturnType<typeof getCaseShareTokens>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    projectId: string,
    caseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCaseShareTokens>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all share tokens for the current guest user
 */

export function useGetCaseShareTokens<TData = Awaited<ReturnType<typeof getCaseShareTokens>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    projectId: string,
    caseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCaseShareTokens>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCaseShareTokensQueryOptions(organizationId,projectId,caseId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Revoke guest access to a specific case
 */
export const revokeGuestAccess = (
    organizationId: string,
    projectId: string,
    caseId: string,
    accessId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/organizations/${organizationId}/projects/${projectId}/cases/${caseId}/guests/${accessId}`, method: 'DELETE', signal
    },
      options);
    }




export const getRevokeGuestAccessMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeGuestAccess>>, TError,{organizationId: string;projectId: string;caseId: string;accessId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof revokeGuestAccess>>, TError,{organizationId: string;projectId: string;caseId: string;accessId: string}, TContext> => {

const mutationKey = ['revokeGuestAccess'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeGuestAccess>>, {organizationId: string;projectId: string;caseId: string;accessId: string}> = (props) => {
          const {organizationId,projectId,caseId,accessId} = props ?? {};

          return  revokeGuestAccess(organizationId,projectId,caseId,accessId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RevokeGuestAccessMutationResult = NonNullable<Awaited<ReturnType<typeof revokeGuestAccess>>>

    export type RevokeGuestAccessMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Revoke guest access to a specific case
 */
export const useRevokeGuestAccess = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeGuestAccess>>, TError,{organizationId: string;projectId: string;caseId: string;accessId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof revokeGuestAccess>>,
        TError,
        {organizationId: string;projectId: string;caseId: string;accessId: string},
        TContext
      > => {
      return useMutation(getRevokeGuestAccessMutationOptions(options), queryClient);
    }
    /**
 * Returns all cases that a guest user has access to within the organization
 * @summary Get all guest accesses for a specific user
 */
export const getUserGuestAccesses = (
    organizationId: string,
    userId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GetUserGuestAccesses200Item[]>(
      {url: `/organizations/${organizationId}/users/${userId}/guest-accesses`, method: 'GET', signal
    },
      options);
    }




export const getGetUserGuestAccessesQueryKey = (organizationId: string,
    userId: string,) => {
    return [
    `/organizations/${organizationId}/users/${userId}/guest-accesses`
    ] as const;
    }


export const getGetUserGuestAccessesQueryOptions = <TData = Awaited<ReturnType<typeof getUserGuestAccesses>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(organizationId: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserGuestAccesses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserGuestAccessesQueryKey(organizationId,userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserGuestAccesses>>> = ({ signal }) => getUserGuestAccesses(organizationId,userId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: organizationId !== null && organizationId !== undefined && userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserGuestAccesses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserGuestAccessesQueryResult = NonNullable<Awaited<ReturnType<typeof getUserGuestAccesses>>>
export type GetUserGuestAccessesQueryError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse


export function useGetUserGuestAccesses<TData = Awaited<ReturnType<typeof getUserGuestAccesses>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserGuestAccesses>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserGuestAccesses>>,
          TError,
          Awaited<ReturnType<typeof getUserGuestAccesses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserGuestAccesses<TData = Awaited<ReturnType<typeof getUserGuestAccesses>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserGuestAccesses>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserGuestAccesses>>,
          TError,
          Awaited<ReturnType<typeof getUserGuestAccesses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserGuestAccesses<TData = Awaited<ReturnType<typeof getUserGuestAccesses>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserGuestAccesses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all guest accesses for a specific user
 */

export function useGetUserGuestAccesses<TData = Awaited<ReturnType<typeof getUserGuestAccesses>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserGuestAccesses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserGuestAccessesQueryOptions(organizationId,userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Returns the password validation rules from Cognito
 */
export const getPasswordRules = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GetPasswordRules200>(
      {url: `/organizations/password-rules`, method: 'GET', signal
    },
      options);
    }




export const getGetPasswordRulesQueryKey = () => {
    return [
    `/organizations/password-rules`
    ] as const;
    }


export const getGetPasswordRulesQueryOptions = <TData = Awaited<ReturnType<typeof getPasswordRules>>, TError = InternalServerErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPasswordRules>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPasswordRulesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPasswordRules>>> = ({ signal }) => getPasswordRules(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPasswordRules>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPasswordRulesQueryResult = NonNullable<Awaited<ReturnType<typeof getPasswordRules>>>
export type GetPasswordRulesQueryError = InternalServerErrorResponse


export function useGetPasswordRules<TData = Awaited<ReturnType<typeof getPasswordRules>>, TError = InternalServerErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPasswordRules>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPasswordRules>>,
          TError,
          Awaited<ReturnType<typeof getPasswordRules>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPasswordRules<TData = Awaited<ReturnType<typeof getPasswordRules>>, TError = InternalServerErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPasswordRules>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPasswordRules>>,
          TError,
          Awaited<ReturnType<typeof getPasswordRules>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPasswordRules<TData = Awaited<ReturnType<typeof getPasswordRules>>, TError = InternalServerErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPasswordRules>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns the password validation rules from Cognito
 */

export function useGetPasswordRules<TData = Awaited<ReturnType<typeof getPasswordRules>>, TError = InternalServerErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPasswordRules>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPasswordRulesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






